<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <div class="searchBox">
      <el-input
        style="width: 200px; margin-right: 10px"
        v-model="searchValue"
        placeholder="请输入搜索内容"
      ></el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button type="primary" @click="handleReset">重置</el-button>
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80" label="序号"> </el-table-column>
      <el-table-column prop="Name" label="姓名" width="100"></el-table-column>
      <el-table-column prop="PhoneNum" label="手机号"></el-table-column>
      <el-table-column prop="LocationRegionId" label="地区id"></el-table-column>
      <el-table-column
        prop="LocationRegionInfo"
        label="地区名称"
        width="180"
      ></el-table-column>
      <el-table-column prop="Detailed" label="详细地址"></el-table-column>
      <el-table-column
        prop="Lable"
        label="地址标签"
        :formatter="labelFormat"
      ></el-table-column>
      <el-table-column
        prop="IsDef"
        label="是否默认"
        :formatter="defaultFormat"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { addressList, deleteAddress } from "@/api/address/address";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      searchValue:''
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
  methods: {
    handleSearch() {
      this.initPage();
      this.getList();
    },
    handleReset(){
      this.searchValue = ''
      this.initPage();
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteAddress({
          id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
    labelFormat(row, column, cellValue, index) {
      return cellValue == 1 ? "家" : cellValue == 2 ? "公司" : "宿舍";
    },
    defaultFormat(row, column, cellValue, index) {
      return cellValue ? "是" : "否";
    },

    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        key: this.searchValue
      };
      addressList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    callFunction(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style lang="scss" scoped>
.searchBox {
  display: flex;
  align-items: center;
  margin: 20px;
}
</style>